module.exports = __webpack_public_path__ + "img/失望.ddac9154.png";